'use strict';

/** @type {import('.')} */
module.exports = Error;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/index.js
 ** module id = 1068
 ** module chunks = 0
 **/